import React, {useState, useEffect} from 'react'
import {Box, Grid, IconButton, useMediaQuery, useTheme} from "@mui/material";
import {FlexBox, FlexRowCenter} from "components/flex-box";
import LazyImage from "components/LazyImage";
import {getImage, getImageFromURL, getLocalDate, openGoogleImageSearch, openGoogleMapLocation} from "helpers/utils";
import BazaarAvatar from "components/BazaarAvatar";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";

const ImageAlbumAdmin = ({images, showLink}) => {

    const [selectedImage, setSelectedImage] = useState(0);
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    
    // Reset to first image when images change
    useEffect(() => {
        setSelectedImage(0);
    }, [images]);
    
    // Determine image size based on screen size
    const getImageSize = () => {
        if (isXs) return { width: 280, height: 280, mockHeight: 280 };
        if (isSm) return { width: 350, height: 350, mockHeight: 350 };
        if (isMd) return { width: 400, height: 400, mockHeight: 400 };
        return { width: 500, height: 500, mockHeight: 500 }; // lg and xl
    };
    
    const imageSize = getImageSize();

    const handleImageClick = (ind) => () => {
        setSelectedImage(ind);
    };

    return (
        <Grid item md={6} xs={12} alignItems="center" display="flex" flexDirection="column" justifyContent="center">
            <FlexBox overflow="auto" justifyContent="center" width="100%">
                {images && images.map((url, ind) => (
                    <FlexRowCenter
                        key={ind}
                        width={64}
                        height={64}
                        minWidth={64}
                        bgcolor="white"
                        border="1px solid"
                        borderRadius="10px"
                        ml={ind === 0 ? "auto" : 0}
                        style={{
                            cursor: "pointer",
                        }}
                        onClick={handleImageClick(ind)}
                        mr={ind === images.length - 1 ? "auto" : "10px"}
                        borderColor={
                            selectedImage === ind ? "primary.main" : "grey.400"
                        }
                    >
                        <BazaarAvatar src={getImageFromURL(url)} variant="square" height={40} />
                    </FlexRowCenter>
                ))}
            </FlexBox>
            <Box justifyContent="center" width="100%">
                <Box>
                <LazyImage
                    width={imageSize.width}
                    height={imageSize.height}
                    mockHeight={imageSize.mockHeight}
                    loading="eager"
                    objectFit="contain"
                    src={getImage(images, selectedImage)}
                />
                </Box>
                <FlexBox overflow="auto">
                    <Box width="70%">
                        {showLink && images && images.length > 0 && <>
                            {getLocalDate(images[selectedImage].cdn.created_at, DATE_TIME_FORMAT_SHORT) }
                            {images[selectedImage].created_ip }
                            {images[selectedImage].location &&  <IconButton
                                size="small"
                                onClick={() => openGoogleMapLocation(images[selectedImage].location)}
                            >
                                <ArrowForwardIcon color="primary"/>
                            </IconButton>}
                        </>}
                    </Box>
                    <Box width="30%">
                        {showLink && <IconButton
                            size="small"
                            onClick={() => openGoogleImageSearch(getImage(images, selectedImage))}
                        >
                           Search <ArrowForwardIcon color="primary"/>
                        </IconButton>
                        }
                    </Box>
                </FlexBox>
            </Box>
        </Grid>
    )
}


export default ImageAlbumAdmin;
